import { ColumnDefBase } from '@tanstack/react-table';
import { ColumnTypesInternal } from '../Types';

export const isActionColumn = <TData, TValue>(column: ColumnDefBase<TData, TValue>) => {
  return (
    column.meta?.type === ColumnTypesInternal.procuros_select ||
    column.meta?.type === ColumnTypesInternal.procuros_delete
  );
};
